import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, onMounted } from 'vue';
import TuiButton from '../Button.vue';
import SvgIcon from '../SvgIcon.vue';
import CloseIcon from '../../icons/CloseIcon.vue';
import useZIndex from '../../../../hooks/useZIndex';
import { isMobile } from '../../../../utils/environment';
import ApplyTipsIcon from '../../icons/ApplyTipsIcon.vue';

type BeforeCloseFn = () => void;

interface Props {
  message: string;
  confirm?: BeforeCloseFn | null;
  cancel?: BeforeCloseFn | null;
  confirmButtonText?: string;
  cancelButtonText?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    message: { default: '' },
    confirm: { type: [Function, null], default: null },
    cancel: { type: [Function, null], default: null },
    confirmButtonText: { default: '' },
    cancelButtonText: { default: '' }
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props as { message: string, confirm: BeforeCloseFn | null, cancel: BeforeCloseFn | null, confirmButtonText: string, cancelButtonText: string };

const visible = ref(false);
const overlayContainerStyle = ref({});
const { nextZIndex } = useZIndex();





watch(visible, val => {
  if (val) {
    overlayContainerStyle.value = { zIndex: nextZIndex() };
  }
});

function handleClose() {
  visible.value = false;
  emit('close');
}

function handleAgree() {
  if (props.confirm) {
    props.confirm();
  }
  handleClose();
}

function handleReject() {
  if (props.cancel) {
    props.cancel();
  }
  handleClose();
}

function onOpen() {
  visible.value = true;
}

onMounted(async () => {
  onOpen();
});

return { __sfc: true,visible, overlayContainerStyle, nextZIndex, props, emit, handleClose, handleAgree, handleReject, onOpen, TuiButton, SvgIcon, CloseIcon, isMobile, ApplyTipsIcon }
}

})